<div class="header row">
    <div class="col-12">
        <h2><strong>Pratiche</strong></h2>
        <div *ngIf="false" class="breadcrumb-wrapper hidden-xs">
            <ol class="breadcrumb">
                <li class="active">Pratiche</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content">
                <div class="view-switcher" role="tablist" aria-label="Viste delle pratiche">
                    <button type="button"
                            role="tab"
                            class="view-tab"
                            [class.active]="activeView === 'base'"
                            [attr.aria-selected]="activeView === 'base'"
                            (click)="setView('base')">
                        <i class="fa fa-th-list"></i>
                        <span>Vista Base</span>
                    </button>
                    <button type="button"
                            role="tab"
                            class="view-tab"
                            [class.active]="activeView === 'dns'"
                            [attr.aria-selected]="activeView === 'dns'"
                            (click)="setView('dns')">
                        <i class="fa fa-file-text-o"></i>
                        <span>Vista Domanda Nuova Sabatini</span>
                    </button>
                    <button type="button"
                            role="tab"
                            class="view-tab"
                            [class.active]="activeView === 'iper'"
                            [attr.aria-selected]="activeView === 'iper'"
                            (click)="setView('iper')">
                        <i class="fa fa-cogs"></i>
                        <span>Vista Iperammortamento 4.0</span>
                    </button>
                </div>
                <div *ngIf="copyFeedbackMessage"
                     class="alert alert-{{ copyFeedbackType }} copy-feedback-alert"
                     role="alert">
                    {{ copyFeedbackMessage }}
                </div>
                <div *ngIf="requests!.length > 0; else customersEmpty">
                    <ng-container *ngIf="(viewRequests
                          | advancedSearchFilter: advancedFields: advancedState
                          | globalSearchFilter: globalSearchFilterValue
                          | idFilter: idFilterValue
                          | creationDateFilter: creationDateFromFilterValue: creationDateToFilterValue
                          | companyNameFilter: companyNameFilterValue
                          | requestTypeFilter: requestTypeFilterValue
                          | emailFilter: emailFilterValue
                          | internalManagementFilter: internalManagementFilterValue
                          | mobilePhoneFilter: mobilePhoneFilterValue
                          | progressStatusFilter: (activeView === 'base' ? progressStatusFilterValue : [])
                          | dnsProblemFilter: activeView: stampProblemFilterValue: cupProblemFilterValue: practicePhaseFilterValue: notesFilterValue: folderNameFilterValue
                          | iperProblemFilter: activeView: iperPhaseFilterValue: iperProblemFilterValue: notesFilterValue: folderNameFilterValue) as filteredRequests">
                        <app-advanced-search [fields]="advancedFields"
                                             [state]="advancedState"
                                             (stateChange)="onAdvancedStateChange($event)"></app-advanced-search>

                        <div class="dashboard-toolbar">
                            <div class="toolbar-left">
                                <label for="items-per-page">Mostra</label>
                                <input [(ngModel)]="paginationConfig.itemsPerPage"
                                       (change)="paginationConfig.currentPage = 1"
                                       class="form-control input-sm form-white items-per-page-input"
                                       id="items-per-page"
                                       name="items-per-page"
                                       type="number">
                                <span class="results-count">
                                    di {{ filteredRequests.length }}
                                    {{ filteredRequests.length === 1 ? 'pratica' : 'pratiche' }}
                                </span>
                                <button *ngIf="hasActiveFilters()"
                                        type="button"
                                        class="btn btn-link btn-sm clear-filters-link"
                                        (click)="clearFilters()">
                                    Pulisci filtri
                                </button>
                            </div>

                            <div class="toolbar-center">
                                <span class="date-filter-label">Data creazione</span>
                                <label class="date-filter-field" for="creation-date-from">
                                    <span>Da</span>
                                    <input [(ngModel)]="creationDateFromFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="date"
                                           class="form-control form-white"
                                           id="creation-date-from"
                                           name="creation-date-from">
                                </label>
                                <label class="date-filter-field" for="creation-date-to">
                                    <span>A</span>
                                    <input [(ngModel)]="creationDateToFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="date"
                                           class="form-control form-white"
                                           id="creation-date-to"
                                           name="creation-date-to">
                                </label>
                            </div>

                            <div class="toolbar-right">
                                <button type="button"
                                        class="btn btn-sm btn-secondary export-csv-btn"
                                        [disabled]="filteredRequests.length === 0"
                                        (click)="exportCsv(filteredRequests)"
                                        title="Esporta in CSV le pratiche filtrate">
                                    <i class="fa fa-download" style="margin-right: 7px;"></i>CSV
                                </button>
                                <a *ngIf="user.FKIDUserRole === 1"
                                   (click)="openCreateRequestModal()"
                                   class="edit btn btn-sm btn-primary">
                                    <i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuova Pratica
                                </a>
                            </div>
                        </div>

                        <div class="row mobile-search-row">
                            <div class="col-xs-12">
                                <div class="form-group prepend-icon">
                                    <input [(ngModel)]="globalSearchFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="text"
                                           class="form-control form-white"
                                           id="mobile-global-search"
                                           name="mobile-global-search"
                                           placeholder="Cerca ID, ragione sociale, email, cellulare...">
                                    <i class="icon-magnifier"></i>
                                </div>
                            </div>
                        </div>

                        <div class="table-container table-scroll" *ngIf="activeView === 'base'">
                            <table class="table table-hover table-customer"
                                   [class.table-sticky-pair]="user.FKIDUserRole === 1"
                                   [appStableColumns]="columnLayoutToken">
                                <thead>
                                <tr class="column-titles">
                                    <th class="col-id">ID Pratica</th>
                                    <th>Data Creazione</th>
                                    <th class="col-flex">Ragione Sociale</th>
                                    <th>Tipologia</th>
                                    <th>Email</th>
                                    <th>Gestione Interna</th>
                                    <th>Cellulare</th>
                                    <th class="status-filter-col">Stato</th>
                                    <th title="DNS completata">DNS</th>
                                    <th title="Iper 4.0 completato">Iper 4.0</th>
                                    <th *ngIf="user.FKIDUserRole === 1" class="notes-col col-sticky col-sticky-notes">Note</th>
                                    <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                                </tr>
                                <tr class="column-filters hidden-xs hidden-sm">
                                    <th class="col-id">
                                        <input [(ngModel)]="idFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="ID"
                                               aria-label="Filtra per ID pratica">
                                    </th>
                                    <th></th>
                                    <th class="col-flex">
                                        <input [(ngModel)]="companyNameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Nome"
                                               aria-label="Filtra per ragione sociale">
                                    </th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="request-type-filter"
                                                    aria-label="Filtra per tipologia"
                                                    [title]="getRequestTypeFilterLabel()">
                                                <span class="status-filter-label">{{ getRequestTypeFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Tipologie pratica">
                                                <label *ngFor="let requestType of requestTypes"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isRequestTypeSelected(requestType.IDRequestType)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onRequestTypeToggle(requestType.IDRequestType, $event)">
                                                    <span>{{ requestType.RequestType }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th>
                                        <input [(ngModel)]="emailFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Email"
                                               aria-label="Filtra per email">
                                    </th>
                                    <th>
                                        <select [(ngModel)]="internalManagementFilterValue"
                                                (ngModelChange)="onFilterChange()"
                                                class="form-control form-white column-filter-control"
                                                name="internal-management-filter"
                                                aria-label="Filtra per gestione interna">
                                            <option value="">Tutte</option>
                                            <option value="yes">Sì</option>
                                            <option value="no">No</option>
                                        </select>
                                    </th>
                                    <th>
                                        <input [(ngModel)]="mobilePhoneFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Cellulare"
                                               aria-label="Filtra per cellulare">
                                    </th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="progress-status-filter"
                                                    aria-label="Filtra per stato"
                                                    [title]="getProgressStatusFilterLabel()">
                                                <span class="status-filter-label">{{ getProgressStatusFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Stati pratica">
                                                <label *ngFor="let status of progressStatusOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isProgressStatusSelected(status)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onProgressStatusToggle(status, $event)">
                                                    <span>{{ status }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th></th>
                                    <th></th>
                                    <th *ngIf="user.FKIDUserRole === 1" class="col-sticky col-sticky-notes"></th>
                                    <th class="col-sticky col-sticky-actions"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngIf="filteredRequests.length === 0">
                                    <td [attr.colspan]="user.FKIDUserRole === 1 ? 12 : 11" class="filtered-empty-state">
                                        <div class="filtered-empty-pin">
                                            <p>Nessun risultato con i filtri attuali.</p>
                                            <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">Pulisci filtri</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let request of filteredRequests | paginate: paginationConfig">
                                    <td class="col-id" (click)="goToRequestDetail(request.IDRequest)">{{ request.IDRequest }}</td>

                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.CreationDate | date: 'dd/MM/YYYY HH:mm' }}</td>

                                    <td *ngIf="request.customer?.CompanyName" (click)="goToRequestDetail(request.IDRequest)">{{ request.customer?.CompanyName }}</td>
                                    <td *ngIf="!request.customer?.CompanyName" (click)="goToRequestDetail(request.IDRequest)" [innerHTML]="'<i>Da Compilare</i>'"></td>

                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.request_type.RequestType }}</td>
                                    <td (click)="goToRequestDetail(request.IDRequest)" [title]="request.Email">{{ request.Email }}</td>
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.InternalManagement ? 'Sì' : 'No' }}</td>

                                    <td *ngIf="request.customer?.MobilePhone" (click)="goToRequestDetail(request.IDRequest)">{{ request.customer?.MobilePhone }}</td>
                                    <td *ngIf="!request.customer?.MobilePhone" (click)="goToRequestDetail(request.IDRequest)" [innerHTML]="'<i>Da Compilare</i>'"></td>

                                    <td *ngIf="request.ProgressStatus < 9" (click)="goToRequestDetail(request.IDRequest)"><span class="badge badge-progress">In fase di compilazione</span></td>
                                    <td *ngIf="request.ProgressStatus === 9 && !request.CompanyParticipation && !request.PartnersParticipation" (click)="goToRequestDetail(request.IDRequest)"><span class="badge badge-info">Da convalidare</span></td>
                                    <td *ngIf="request.ProgressStatus === 9 && (request.CompanyParticipation || request.PartnersParticipation)" (click)="goToRequestDetail(request.IDRequest)"><span class="badge badge-warning">Da controllare</span></td>
                                    <td *ngIf="request.ProgressStatus === 10" (click)="goToRequestDetail(request.IDRequest)"><span class="badge badge-success">Completato</span></td>

                                    <td class="completion-status-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <span *ngIf="request.FKIDRequestType === 6"
                                              class="completion-status-indicator"
                                              [class.completion-status-indicator--done]="request.DNSCompleted"
                                              [class.completion-status-indicator--pending]="!request.DNSCompleted"
                                              [attr.aria-label]="request.DNSCompleted ? 'DNS completato' : 'DNS non completato'">
                                            <svg *ngIf="request.DNSCompleted" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg *ngIf="!request.DNSCompleted" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                <path d="M4.25 4.25 L11.75 11.75 M11.75 4.25 L4.25 11.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round"/>
                                            </svg>
                                        </span>
                                        <span *ngIf="request.FKIDRequestType !== 6">-</span>
                                    </td>
                                    <td class="completion-status-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <span *ngIf="request.FKIDRequestType === 6"
                                              class="completion-status-indicator"
                                              [class.completion-status-indicator--done]="request.Iper4Completed"
                                              [class.completion-status-indicator--pending]="!request.Iper4Completed"
                                              [attr.aria-label]="request.Iper4Completed ? 'Iper 4.0 completato' : 'Iper 4.0 non completato'">
                                            <svg *ngIf="request.Iper4Completed" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <svg *ngIf="!request.Iper4Completed" class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                <path d="M4.25 4.25 L11.75 11.75 M11.75 4.25 L4.25 11.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round"/>
                                            </svg>
                                        </span>
                                        <span *ngIf="request.FKIDRequestType !== 6">-</span>
                                    </td>

                                    <td *ngIf="user.FKIDUserRole === 1" class="notes-cell col-sticky col-sticky-notes">
                                        <button type="button"
                                                class="btn btn-xs notes-btn"
                                                [class.btn-primary]="hasNotes(request)"
                                                [class.btn-secondary]="!hasNotes(request)"
                                                (click)="openNotesModal(request)">
                                            <i class="fa fa-comment-o"></i><span>Note</span>
                                        </button>
                                    </td>

                                    <td class="text-right col-sticky col-sticky-actions">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="btn-group">
                                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                                Azioni
                                            </button>
                                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right row-actions-menu">
                                                <button *ngIf="request.ProgressStatus === 9 && user.FKIDUserRole === 1" (click)="openCompleteRequestModal(request)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Completa</button>
                                                <button *ngIf="request.ProgressStatus === 10 && user.FKIDUserRole === 1" (click)="openUncompleteRequestModal(request)" class="dropdown-item" type="button"><i class="fa fa-times"></i>Annulla</button>
                                                <button *ngIf="request.FKIDRequestType === 6 && !request.DNSCompleted" (click)="openCompleteDnsModal(request)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Completa DNS</button>
                                                <button *ngIf="request.FKIDRequestType === 6 && request.DNSCompleted" (click)="openUncompleteDnsModal(request)" class="dropdown-item" type="button"><i class="fa fa-undo"></i>Annulla completamento DNS</button>
                                                <button *ngIf="request.FKIDRequestType === 6 && !request.Iper4Completed" (click)="openCompleteIper4Modal(request)" class="dropdown-item" type="button"><i class="fa fa-check"></i>Completa Iper 4.0</button>
                                                <button *ngIf="request.FKIDRequestType === 6 && request.Iper4Completed" (click)="openUncompleteIper4Modal(request)" class="dropdown-item" type="button"><i class="fa fa-undo"></i>Annulla completamento Iper 4.0</button>
                                                <button *ngIf="!request.InternalManagement" (click)="openSendReminderModal(request)" class="dropdown-item" type="button"><i class="fa fa-envelope"></i>Invia Sollecito</button>
                                                <a (click)="copyRequestLink(request.user_session.Token)" class="dropdown-item" type="button"><i class="fa fa-link"></i>Link</a>
                                                <button *ngIf="user.FKIDUserRole === 1" (click)="openAccessesModal(request)" class="dropdown-item" type="button"><i class="fa fa-eye"></i>Accessi</button>
                                                <a *ngIf="user.FKIDUserRole === 1" [routerLink]="['/richiesta/modifica/' + request.IDRequest]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Modifica</a>
                                                <a *ngIf="(user.FKIDUserRole === 2 || user.FKIDUserRole === 3 || user.FKIDUserRole === 4) && request.FKIDRequestType === 5" [routerLink]="['/richiesta/compilazione/' + request.IDRequest]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Compila</a>
                                                <button *ngIf="user.FKIDUserRole === 1" (click)="openDeleteRequestModal(request)" class="dropdown-item" type="button"><i class="fa fa-trash-o"></i>Elimina</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-container table-scroll" *ngIf="activeView === 'dns'">
                            <table class="table table-hover table-customer"
                                   [appStableColumns]="columnLayoutToken">
                                <thead>
                                <tr class="column-titles">
                                    <th>ID</th>
                                    <th>Data Creazione</th>
                                    <th>Gestione Interna</th>
                                    <th class="col-flex">Ragione Sociale / Denominazione</th>
                                    <th>Nome cartella pratica</th>
                                    <th>Data Analisi</th>
                                    <th>Fase Pratica</th>
                                    <th>Problemi Sottofase 1</th>
                                    <th>Problemi Sottofase 2</th>
                                    <th class="col-wrap">Note</th>
                                </tr>
                                <tr class="column-filters hidden-xs hidden-sm">
                                    <th>
                                        <input [(ngModel)]="idFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="ID"
                                               aria-label="Filtra per ID pratica">
                                    </th>
                                    <th></th>
                                    <th>
                                        <select [(ngModel)]="internalManagementFilterValue"
                                                (ngModelChange)="onFilterChange()"
                                                class="form-control form-white column-filter-control"
                                                name="dns-internal-management-filter"
                                                aria-label="Filtra per gestione interna">
                                            <option value="">Tutte</option>
                                            <option value="yes">Sì</option>
                                            <option value="no">No</option>
                                        </select>
                                    </th>
                                    <th class="col-flex">
                                        <input [(ngModel)]="companyNameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Nome"
                                               aria-label="Filtra per ragione sociale">
                                    </th>
                                    <th>
                                        <input [(ngModel)]="folderNameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Cartella"
                                               aria-label="Filtra per nome cartella pratica">
                                    </th>
                                    <th></th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="practice-phase-filter"
                                                    aria-label="Filtra per fase pratica"
                                                    [title]="getPracticePhaseFilterLabel()">
                                                <span class="status-filter-label">{{ getPracticePhaseFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Fase pratica">
                                                <label *ngFor="let option of practicePhaseFilterOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isPracticePhaseSelected(option)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onPracticePhaseToggle(option, $event)">
                                                    <span>{{ option }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="stamp-problem-filter"
                                                    aria-label="Filtra per problemi sottofase 1"
                                                    [title]="getStampProblemFilterLabel()">
                                                <span class="status-filter-label">{{ getStampProblemFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Problemi sottofase 1">
                                                <label *ngFor="let option of stampProblemOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isStampProblemSelected(option)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onStampProblemToggle(option, $event)">
                                                    <span>{{ option }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="cup-problem-filter"
                                                    aria-label="Filtra per problema sottofase 2"
                                                    [title]="getCupProblemFilterLabel()">
                                                <span class="status-filter-label">{{ getCupProblemFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Problema sottofase 2">
                                                <label *ngFor="let option of cupProblemOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isCupProblemSelected(option)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onCupProblemToggle(option, $event)">
                                                    <span>{{ option }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="col-wrap">
                                        <input [(ngModel)]="notesFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Note"
                                               aria-label="Filtra per note">
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngIf="filteredRequests.length === 0">
                                    <td colspan="10" class="filtered-empty-state">
                                        <div class="filtered-empty-pin">
                                            <p *ngIf="hasActiveFilters(); else dnsViewEmpty">Nessun risultato con i filtri attuali.</p>
                                            <ng-template #dnsViewEmpty>
                                                <p>Nessuna pratica DNS o DNS + Iperammortamento 4.0 completata.</p>
                                            </ng-template>
                                            <button *ngIf="hasActiveFilters()" type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">Pulisci filtri</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let request of filteredRequests | paginate: paginationConfig">
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.IDRequest }}</td>
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.CreationDate | date: 'dd/MM/YYYY HH:mm' }}</td>
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.InternalManagement ? 'Sì' : 'No' }}</td>
                                    <td *ngIf="request.customer?.CompanyName" class="col-flex" (click)="goToRequestDetail(request.IDRequest)">{{ request.customer?.CompanyName }}</td>
                                    <td *ngIf="!request.customer?.CompanyName" class="col-flex" (click)="goToRequestDetail(request.IDRequest)"><i>Da Compilare</i></td>
                                    <td class="practice-folder" (click)="goToRequestDetail(request.IDRequest)">{{ practiceFolderName(request) }}</td>
                                    <!-- Nessun campo Data Analisi nei dati pratica: la colonna resta vuota. -->
                                    <td (click)="goToRequestDetail(request.IDRequest)"></td>
                                    <td class="practice-phase-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <span class="practice-phase-badge"
                                              [class.practice-phase-badge--1]="practicePhase(request) === 1"
                                              [class.practice-phase-badge--2]="practicePhase(request) === 2"
                                              [attr.aria-label]="practicePhaseLabel(request)">
                                            {{ practicePhaseLabel(request) }}
                                        </span>
                                    </td>
                                    <td class="problem-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <div class="problem-list" *ngIf="hasPhase1Problem(request); else phase1Ok">
                                            <span *ngIf="stampProblemLabel(request) as stampProblem"
                                                  class="badge badge-danger stamp-problem-badge"
                                                  role="button"
                                                  tabindex="0"
                                                  (click)="openRevenueStampModal(request, $event)">{{ stampProblem }}</span>
                                            <span *ngIf="participationProblemLabel(request) as participationProblem"
                                                  class="badge badge-danger">{{ participationProblem }}</span>
                                        </div>
                                        <ng-template #phase1Ok>
                                            <span class="completion-status-indicator completion-status-indicator--done"
                                                  aria-label="Nessun problema sottofase 1"
                                                  title="Nessun problema">
                                                <svg class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                    <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </ng-template>
                                    </td>
                                    <td class="problem-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <div class="problem-list" *ngIf="cupProblemLabel(request) as cupProblem; else cupOk">
                                            <span class="badge badge-danger">{{ cupProblem }}</span>
                                        </div>
                                        <ng-template #cupOk>
                                            <span class="completion-status-indicator completion-status-indicator--done"
                                                  aria-label="Nessun problema sottofase 2"
                                                  title="Nessun problema">
                                                <svg class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                    <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </ng-template>
                                    </td>
                                    <td class="col-wrap dns-notes" (click)="goToRequestDetail(request.IDRequest)" [title]="request.Notes">{{ request.Notes }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-container table-scroll" *ngIf="activeView === 'iper'">
                            <table class="table table-hover table-customer"
                                   [appStableColumns]="columnLayoutToken">
                                <thead>
                                <tr class="column-titles">
                                    <th>ID</th>
                                    <th>Data Creazione</th>
                                    <th>Gestione Interna</th>
                                    <th class="col-flex">Ragione Sociale / Denominazione</th>
                                    <th>Nome cartella pratica</th>
                                    <th>Data Analisi</th>
                                    <th>Fase Pratica</th>
                                    <th>Problemi</th>
                                    <th>Importo Agevolazione</th>
                                    <th class="col-wrap">Note</th>
                                </tr>
                                <tr class="column-filters hidden-xs hidden-sm">
                                    <th>
                                        <input [(ngModel)]="idFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="ID"
                                               aria-label="Filtra per ID pratica">
                                    </th>
                                    <th></th>
                                    <th>
                                        <select [(ngModel)]="internalManagementFilterValue"
                                                (ngModelChange)="onFilterChange()"
                                                class="form-control form-white column-filter-control"
                                                name="iper-internal-management-filter"
                                                aria-label="Filtra per gestione interna">
                                            <option value="">Tutte</option>
                                            <option value="yes">Sì</option>
                                            <option value="no">No</option>
                                        </select>
                                    </th>
                                    <th class="col-flex">
                                        <input [(ngModel)]="companyNameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Nome"
                                               aria-label="Filtra per ragione sociale">
                                    </th>
                                    <th>
                                        <input [(ngModel)]="folderNameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Cartella"
                                               aria-label="Filtra per nome cartella pratica">
                                    </th>
                                    <th></th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="iper-phase-filter"
                                                    aria-label="Filtra per fase pratica"
                                                    [title]="getIperPhaseFilterLabel()">
                                                <span class="status-filter-label">{{ getIperPhaseFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Fase pratica">
                                                <label *ngFor="let option of iperPhaseFilterOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isIperPhaseSelected(option)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onIperPhaseToggle(option, $event)">
                                                    <span>{{ option }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="status-filter-col">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="status-filter">
                                            <button type="button"
                                                    class="form-control form-white column-filter-control status-filter-toggle"
                                                    ngbDropdownToggle
                                                    name="iper-problem-filter"
                                                    aria-label="Filtra per problemi"
                                                    [title]="getIperProblemFilterLabel()">
                                                <span class="status-filter-label">{{ getIperProblemFilterLabel() }}</span>
                                            </button>
                                            <div ngbDropdownMenu class="status-filter-menu dropdown-menu-right" aria-label="Problemi">
                                                <label *ngFor="let option of iperProblemOptions"
                                                       class="status-filter-option">
                                                    <input type="checkbox"
                                                           [checked]="isIperProblemSelected(option)"
                                                           (click)="$event.stopPropagation()"
                                                           (change)="onIperProblemToggle(option, $event)">
                                                    <span>{{ option }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </th>
                                    <th></th>
                                    <th class="col-wrap">
                                        <input [(ngModel)]="notesFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Note"
                                               aria-label="Filtra per note">
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngIf="filteredRequests.length === 0">
                                    <td colspan="10" class="filtered-empty-state">
                                        <div class="filtered-empty-pin">
                                            <p *ngIf="hasActiveFilters(); else iperViewEmpty">Nessun risultato con i filtri attuali.</p>
                                            <ng-template #iperViewEmpty>
                                                <p>Nessuna pratica Iperammortamento 4.0 o DNS + Iperammortamento 4.0 completata.</p>
                                            </ng-template>
                                            <button *ngIf="hasActiveFilters()" type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">Pulisci filtri</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let request of filteredRequests | paginate: paginationConfig">
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.IDRequest }}</td>
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.CreationDate | date: 'dd/MM/YYYY HH:mm' }}</td>
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.InternalManagement ? 'Sì' : 'No' }}</td>
                                    <td *ngIf="request.customer?.CompanyName" class="col-flex" (click)="goToRequestDetail(request.IDRequest)">{{ request.customer?.CompanyName }}</td>
                                    <td *ngIf="!request.customer?.CompanyName" class="col-flex" (click)="goToRequestDetail(request.IDRequest)"><i>Da Compilare</i></td>
                                    <td class="practice-folder" (click)="goToRequestDetail(request.IDRequest)">{{ practiceFolderName(request) }}</td>
                                    <!-- Nessun campo Data Analisi nei dati pratica: la colonna resta vuota. -->
                                    <td (click)="goToRequestDetail(request.IDRequest)"></td>
                                    <td class="practice-phase-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <span class="practice-phase-badge"
                                              [class.practice-phase-badge--preventiva]="iperPhase(request) === 'preventiva'"
                                              [class.practice-phase-badge--intermedia]="iperPhase(request) === 'intermedia'"
                                              [class.practice-phase-badge--completamento]="iperPhase(request) === 'completamento'"
                                              [attr.aria-label]="iperPhaseLabel(request)">
                                            {{ iperPhaseLabel(request) }}
                                        </span>
                                    </td>
                                    <td class="problem-cell" (click)="goToRequestDetail(request.IDRequest)">
                                        <div class="problem-list" *ngIf="iperProblemLabels(request).length; else iperProblemsOk">
                                            <span *ngFor="let problem of iperProblemLabels(request)"
                                                  class="badge badge-danger">{{ problem }}</span>
                                        </div>
                                        <ng-template #iperProblemsOk>
                                            <span class="completion-status-indicator completion-status-indicator--done"
                                                  aria-label="Nessun problema"
                                                  title="Nessun problema">
                                                <svg class="completion-status-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                    <path d="M3.25 8.25 L6.5 11.5 L12.75 4.75" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                        </ng-template>
                                    </td>
                                    <td (click)="goToRequestDetail(request.IDRequest)">{{ request.IncentivePercentageAmount || '-' }}</td>
                                    <td class="col-wrap dns-notes" (click)="goToRequestDetail(request.IDRequest)" [title]="request.Notes">{{ request.Notes }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <pagination-controls *ngIf="filteredRequests.length > 0"
                                             (pageChange)="pageChanged($event)"
                                             [autoHide]="paginationParams.autoHide"
                                             [maxSize]="paginationParams.maxSize"
                                             [responsive]="paginationParams.responsive"
                                             [previousLabel]="paginationLabels.previousLabel"
                                             [nextLabel]="paginationLabels.nextLabel"
                                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                        ></pagination-controls>
                    </ng-container>
                </div>
                <ng-template #customersEmpty>
                    <div>
                        <div class="row">
                            <div class="col-md-3 col-md-offset-9 col-xs-12" style="text-align: right;">
                                <a (click)="openCreateRequestModal()" class="edit btn btn-sm btn-primary"><i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuova Pratica</a>
                            </div>
                        </div>
                        <div style="height: 200px; text-align: center; padding-top: 85px;">
                            Nessuna pratica trovata.
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
